import * as url from "../url.helper";

import { post } from "../api.helper";

export const addPoc = data => post(url.ADD_POC_DETAILS, data);

export const getPoc = data => post(url.GET_POC_DETAILS, data);

export const getAnchorPoc = data => post(url.GET_ANCHOR_POC_DETAILS, data);

export const addCounterpartyPoc = data => post(url.ADD_COUNTERPARTY_POC_DETAILS, data);

export const getCounterparties = data => post(url.GET_COUNTERPARTY_DETAILS, data);

export const addAnchorPoc = data => post(url.ADD_ANCHOR_POC_DETAILS, data);

export const deleteAnchorPoc = data => post(url.DELETE_ANCHOR_POC_DETAILS, data);


export const editPoc = data => post(url.EDIT_POC_DETAILS, data);

export const deletePoc = data => post(url.DELETE_POC_DETAILS, data)

export const setPrimaryPoc = data => post(url.SET_PRIMARY_POC, data);

export const getPrimaryPoc = data => post(url.GET_PRIMARY_POC, data);
